"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiFactory = void 0;
const availability_1 = require("./availability");
const availabilityV3_1 = require("./availabilityV3");
const booking_state_1 = require("./booking-state");
const booking_summaries_1 = require("./booking-summaries");
const bookingcom_1 = require("./bookingcom");
const calendar_source_1 = require("./calendar-source");
const cancellation_preferences_1 = require("./cancellation-preferences");
const commission_1 = require("./commission");
const contracts_1 = require("./contracts");
const customers_1 = require("./customers");
const experiments_1 = require("./experiments");
const facts_1 = require("./facts");
const http_1 = require("./http");
const market_insights_1 = require("./market-insights");
const notifications_1 = require("./notifications");
const pricing_1 = require("./pricing");
const promotions_1 = require("./promotions");
const properties_1 = require("./properties");
const property_scores_1 = require("./property-scores");
const property_shell_1 = require("./property-shell");
const property_summaries_1 = require("./property-summaries");
const getConfiguredHTTP = (baseUrl, transformers) => {
    const requests = http_1.http();
    if (transformers) {
        transformers.forEach((t) => requests.addRequestInterceptor(t));
    }
    requests.setBaseUrl(baseUrl);
    return requests;
};
exports.apiFactory = (config) => {
    const defaultHttp = getConfiguredHTTP(config.serviceSpec.default.baseUrl, config ? config.transformers : []);
    const httpObjects = {
        bookingStateLatestVerification: config.serviceSpec.bookingStateLatestVerification ?
            getConfiguredHTTP(config.serviceSpec.bookingStateLatestVerification.baseUrl) : defaultHttp,
        pricing: config.serviceSpec.pricing ?
            getConfiguredHTTP(config.serviceSpec.pricing.baseUrl) : defaultHttp,
        properties: config.serviceSpec.properties ?
            getConfiguredHTTP(config.serviceSpec.properties.baseUrl) : defaultHttp,
        customers: config.serviceSpec.customers ?
            getConfiguredHTTP(config.serviceSpec.customers.baseUrl) : defaultHttp,
        notifications: config.serviceSpec.notifications ?
            getConfiguredHTTP(config.serviceSpec.notifications.baseUrl) : defaultHttp,
        marketInsights: config.serviceSpec.marketInsights ?
            getConfiguredHTTP(config.serviceSpec.marketInsights.baseUrl) : defaultHttp,
        bookingcom: config.serviceSpec.bookingcom ?
            getConfiguredHTTP(config.serviceSpec.bookingcom.baseUrl) : defaultHttp,
        cancellationPreference: config.serviceSpec.cancellationPreference ?
            getConfiguredHTTP(config.serviceSpec.cancellationPreference.baseUrl) : defaultHttp,
        propertySummaries: config.serviceSpec.propertySummaries ?
            getConfiguredHTTP(config.serviceSpec.propertySummaries.baseUrl) : defaultHttp,
        propertyShell: config.serviceSpec.propertyShell ?
            getConfiguredHTTP(config.serviceSpec.propertyShell.baseUrl) : defaultHttp,
        facts: config.serviceSpec.facts ?
            getConfiguredHTTP(config.serviceSpec.facts.baseUrl) : defaultHttp,
        contracts: config.serviceSpec.contracts ? getConfiguredHTTP(config.serviceSpec.contracts.baseUrl) : defaultHttp,
        bookingSummaries: config.serviceSpec.bookingSummaries ?
            getConfiguredHTTP(config.serviceSpec.bookingSummaries.baseUrl) : defaultHttp,
        availability: config.serviceSpec.availability ?
            getConfiguredHTTP(config.serviceSpec.availability.baseUrl) : defaultHttp,
        availabilityV3: config.serviceSpec.availabilityV3 ?
            getConfiguredHTTP(config.serviceSpec.availabilityV3.baseUrl) : defaultHttp,
        calendarSource: config.serviceSpec.calendarSource ?
            getConfiguredHTTP(config.serviceSpec.calendarSource.baseUrl) : defaultHttp,
        bookingState: config.serviceSpec.bookingState ?
            getConfiguredHTTP(config.serviceSpec.bookingState.baseUrl) : defaultHttp,
        commission: config.serviceSpec.commission ?
            getConfiguredHTTP(config.serviceSpec.commission.baseUrl) : defaultHttp,
        propertyScores: config.serviceSpec.propertyScores ?
            getConfiguredHTTP(config.serviceSpec.propertyScores.baseUrl) : defaultHttp,
        promotions: config.serviceSpec.promotions ?
            getConfiguredHTTP(config.serviceSpec.promotions.baseUrl) : defaultHttp,
        experiments: config.serviceSpec.experiments ?
            getConfiguredHTTP(config.serviceSpec.experiments.baseUrl) : defaultHttp,
    };
    const servicePrefixes = {
        bookingStateLatestVerification: config.serviceSpec.bookingStateLatestVerification && config.serviceSpec.bookingStateLatestVerification.prefix,
        pricing: config.serviceSpec.pricing && config.serviceSpec.pricing.prefix,
        properties: config.serviceSpec.properties && config.serviceSpec.properties.prefix,
        customers: config.serviceSpec.customers && config.serviceSpec.customers.prefix,
        notifications: config.serviceSpec.notifications && config.serviceSpec.notifications.prefix,
        cancellationPreference: config.serviceSpec.cancellationPreference && config.serviceSpec.cancellationPreference.prefix,
        propertySummaries: config.serviceSpec.propertySummaries && config.serviceSpec.propertySummaries.prefix,
        propertyShell: config.serviceSpec.propertyShell && config.serviceSpec.propertyShell.prefix,
        marketInsights: config.serviceSpec.marketInsights && config.serviceSpec.marketInsights.prefix,
        bookingcom: config.serviceSpec.bookingcom && config.serviceSpec.bookingcom.prefix,
        facts: config.serviceSpec.facts && config.serviceSpec.facts.prefix,
        contracts: config.serviceSpec.contracts && config.serviceSpec.contracts.prefix,
        bookingSummaries: config.serviceSpec.bookingSummaries && config.serviceSpec.bookingSummaries.prefix,
        availability: config.serviceSpec.availability && config.serviceSpec.availability.prefix,
        availabilityV3: config.serviceSpec.availabilityV3 && config.serviceSpec.availabilityV3.prefix,
        calendarSource: config.serviceSpec.calendarSource && config.serviceSpec.calendarSource.prefix,
        bookingState: config.serviceSpec.bookingState && config.serviceSpec.bookingState.prefix,
        commission: config.serviceSpec.commission && config.serviceSpec.commission.prefix,
        propertyScores: config.serviceSpec.propertyScores && config.serviceSpec.propertyScores.prefix,
        promotions: config.serviceSpec.promotions && config.serviceSpec.promotions.prefix,
        experiments: config.serviceSpec.experiments && config.serviceSpec.experiments.prefix
    };
    return {
        bookingStateLatestVerification: booking_state_1.bookingStateLatestVerificationApi(httpObjects.bookingStateLatestVerification, servicePrefixes.bookingStateLatestVerification),
        pricing: pricing_1.pricingApi(httpObjects.pricing, servicePrefixes.pricing),
        properties: properties_1.propertiesApi(httpObjects.properties, servicePrefixes.properties),
        customers: customers_1.customersApi(httpObjects.customers, servicePrefixes.customers),
        notifications: notifications_1.notificationsApi(httpObjects.notifications, servicePrefixes.notifications),
        cancellationPreference: cancellation_preferences_1.cancellationPreferenceApi(httpObjects.cancellationPreference, servicePrefixes.cancellationPreference),
        propertySummaries: property_summaries_1.propertySummariesApi(httpObjects.propertySummaries, servicePrefixes.propertySummaries),
        propertyShell: property_shell_1.propertyShellApi(httpObjects.propertyShell, servicePrefixes.propertyShell),
        marketInsights: market_insights_1.marketInsightsApi(httpObjects.marketInsights, servicePrefixes.marketInsights),
        bookingcom: bookingcom_1.bookingcomApi(httpObjects.bookingcom, servicePrefixes.bookingcom),
        facts: facts_1.factsApi(httpObjects.facts, servicePrefixes.facts),
        contracts: contracts_1.contractsApi(httpObjects.contracts, servicePrefixes.contracts),
        bookingSummaries: booking_summaries_1.bookingSummariesApi(httpObjects.bookingSummaries, servicePrefixes.bookingSummaries),
        availability: availability_1.availabilityApi(httpObjects.availability, servicePrefixes.availability),
        availabilityV3: availabilityV3_1.availabilityV3Api(httpObjects.availabilityV3, servicePrefixes.availabilityV3),
        calendarSource: calendar_source_1.calendarSourceApi(httpObjects.calendarSource, servicePrefixes.calendarSource),
        bookingState: booking_state_1.bookingStateApi(httpObjects.bookingState, servicePrefixes.bookingState),
        commission: commission_1.commissionApi(httpObjects.commission, servicePrefixes.commission),
        propertyScores: property_scores_1.propertyScoresApi(httpObjects.propertyScores, servicePrefixes.propertyScores),
        promotions: promotions_1.promotionsApi(httpObjects.promotions, servicePrefixes.promotions),
        experiments: experiments_1.experimentsApi(httpObjects.experiments, servicePrefixes.experiments)
    };
};
//# sourceMappingURL=index.js.map